import * as info from "info";
import { Prefs } from "~/alias/prefs";
import { getExperiments } from "~/alias/uninstall";
import { getUserId } from "~/id/background";
import { License } from "~/picreplacement/check";
import * as utils from "~/utilities/background";
import { getBlockCount } from "./block-count";
import { getIPMPingCount } from "./ping-count";
export const startInfo = {
    getExperiments,
    getIPMPingCount,
    getBlockCount,
    info: {
        async getId() {
            return await getUserId();
        },
        getAppName() {
            return info.baseName;
        },
        getAppVersion() {
            return info.addonVersion;
        },
        getBrowserName() {
            return info.application;
        },
        getBrowserVersion() {
            return info.applicationVersion;
        },
    },
    licensing: {
        async isLicenseValid() {
            await License.ready();
            return License.isActiveLicense();
        },
    },
    logger: utils,
    prefs: Prefs,
};
